import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: !_ctx.isEdit
          ? [
              { title: 'スタッフ一覧', href: '/setting/staff', color: 'primary', disabled: false },
              { title: '新規作成', disabled: true },
            ]
          : [
              { title: 'スタッフ一覧', href: '/setting/staff', color: 'primary', disabled: false },
              { title: `${_ctx.lastName} ${_ctx.firstName}`, href: `/setting/staff/${_ctx.$route.params.id}`, color: 'primary', disabled: false },
              { title: 'アカウント設定', disabled: true },
            ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, { value: "スタッフアカウント設定" }),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.valid) = $event)),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "pt-12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("div", null, "区分*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.category,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category) = $event)),
                      items: _ctx.categorySelectValues,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      rules: [_ctx.required],
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("div", null, "姓*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                      rules: [_ctx.required],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("div", null, "名*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                      rules: [_ctx.required],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("div", null, "姓（カナ）*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.lastNameKana,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastNameKana) = $event)),
                      rules: [_ctx.required, _ctx.isKatakana],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("div", null, "名（カナ）*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.firstNameKana,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.firstNameKana) = $event)),
                      rules: [_ctx.required, _ctx.isKatakana],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _cache[40] || (_cache[40] = _createTextVNode(" スタッフID* ", -1)),
                      _createVNode(_component_v_tooltip, {
                        bottom: "",
                        color: "primary"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({ small: "" }, props), {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode("mdi-information-outline ", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "＠をアルファベットの文字列で挟んだ形式で入力してください。", -1)),
                          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                          _cache[33] || (_cache[33] = _createElementVNode("span", null, "例：［氏名のアルファベット表記］＠［施設名のアルファベット表記］", -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "onamae@shisetumei", -1)),
                          _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("span", null, "※一度使用したスタッフIDは使用しないでください。", -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("span", null, "※個人のメールアドレスは登録しないでください。", -1))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email) = $event)),
                      rules: [_ctx.required, _ctx.isEmail],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("div", null, "生年月日*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.birth,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.birth) = $event)),
                      variant: "outlined",
                      "hide-details": "auto",
                      density: "compact",
                      type: "date",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("div", null, "性別*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.genderSelectValues,
                      modelValue: _ctx.gender,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gender) = $event)),
                      rules: [_ctx.required],
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createElementVNode("div", null, "住所", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.address,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                    _createElementVNode("div", null, "電話番号1", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.phoneNumber1,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.phoneNumber1) = $event)),
                      rules: [_ctx.isTel],
                      placeholder: "ハイフン有り",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                    _createElementVNode("div", null, "電話番号2", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.phoneNumber2,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.phoneNumber2) = $event)),
                      rules: [_ctx.isTel],
                      placeholder: "ハイフン有り",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "py-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createElementVNode("div", null, "施設長", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isDirector,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isDirector) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createElementVNode("div", null, "主任", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isChief,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isChief) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _cache[50] || (_cache[50] = _createTextVNode(" 管理者 ", -1)),
                      _createVNode(_component_v_tooltip, {
                        bottom: "",
                        color: "primary"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({ small: "" }, props), {
                            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                              _createTextVNode("mdi-information-outline ", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[49] || (_cache[49] = _createElementVNode("span", null, "管理者権限は全ての項目の編集ができる権限です", -1))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isAdmin,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isAdmin) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("div", null, "スタッフコード1", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.staffCode1,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.staffCode1) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                    _createElementVNode("div", null, "スタッフコード2", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.staffCode2,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.staffCode2) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createElementVNode("div", null, "入社日*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.joinDate,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.joinDate) = $event)),
                      variant: "outlined",
                      "hide-details": "auto",
                      density: "compact",
                      type: "date",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                    _createElementVNode("div", null, "配属日*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.assignDate,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.assignDate) = $event)),
                      variant: "outlined",
                      "hide-details": "auto",
                      density: "compact",
                      type: "date",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                    _createElementVNode("div", null, "退職日", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.retireDate,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.retireDate) = $event)),
                      variant: "outlined",
                      "hide-details": "auto",
                      density: "compact",
                      type: "date",
                      clearable: "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createElementVNode("div", null, "退職理由", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.retireSelectValues,
                      modelValue: _ctx.retireReason,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.retireReason) = $event)),
                      "item-title": "text",
                      "item-value": "value",
                      density: "compact",
                      variant: "outlined",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.retireReasonComment,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.retireReasonComment) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      label: "理由詳細",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                    _createElementVNode("div", null, "担任クラス", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.classes,
                      modelValue: _ctx.classesInCharge,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.classesInCharge) = $event)),
                      "item-title": "className",
                      "item-value": "classId",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      multiple: "",
                      chips: "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                    _createElementVNode("div", null, "備考", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.comment,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.comment) = $event)),
                      variant: "outlined",
                      label: "備考",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                    _createElementVNode("div", null, "非表示", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isHidden,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isHidden) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    (_ctx.isEdit)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          onClick: _ctx.updateStaff,
                          loading: _ctx.loading,
                          color: "primary",
                          variant: "flat",
                          block: ""
                        }, {
                          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                            _createTextVNode(" 保存 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "loading"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          onClick: _ctx.createStaff,
                          loading: _ctx.loading,
                          disabled: !_ctx.valid,
                          color: "primary",
                          variant: "flat",
                          block: ""
                        }, {
                          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                            _createTextVNode(" 登録 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "loading", "disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}